import React from 'react';
import { RESULT_PROMO_BANNER } from '../../../shared/config/menuResultData';
import { BannerImage, Root } from './ResultPromoBanner.styles';

/** Figma 136:10960 — 랭킹 하단 프로모 배너 (banner.png) */
export function ResultPromoBanner() {
  return (
    <Root aria-hidden="true">
      <BannerImage src={RESULT_PROMO_BANNER.image} alt="" loading="lazy" decoding="async" />
    </Root>
  );
}
